import moment from "moment";

export function DurationTime(ticks: any) {
  const time = ticks / 60;
  const hours = Math.abs(Math.floor(time));
  const minutes = Math.floor((time - hours) * 60);
  return hours + "h" + minutes + "m";
}
export function dateDiff(startDate?: Date, endDate?: Date) {
  const sta = moment(startDate);
  const end = moment(endDate);
  const date = moment.duration(end.diff(sta));
  return `${date.hours() + date.days() * 24}h${date.minutes()}m`;
}

export function daysDiff(startDate?: Date, endDate?: Date) {
  const sta = moment(startDate).format("YYYY-MM-DD");
  const end = moment(endDate).format("YYYY-MM-DD");
  const date = moment(end).diff(moment(sta), "days");
  return date;
}
export function isWeiXin() {
  const ua = window.navigator.userAgent.toLowerCase() as any;
  if (ua.match(/MicroMessenger/i) == "micromessenger") {
    return true;
  } else {
    return false;
  }
}
export function isApp() {
  return (window as any).lch_device_info != undefined;
}

export function isOfw() {
  let ofwTest = /(ofwapp)|(app.ofw.net)|(shfriendwill.com)/gi;
  return ofwTest.test(location.host) || ofwTest.test(location.hostname);
}
